export const tokenAddress= "0x03A22D9F54837ed9Ede7928076EFF19611806Ae8";

export const usdtAddress= "0x55d398326f99059fF775485246999027B3197955";

export const vendorAddress= "0x0A9216fFE8FF1eb485b6f1b0A25EBAA75707a561";

export const stakeAddress= "0xDD7a328724C2325d5CD75590902bf3891d268c79";

export const vestingAddress = "";
